import * as React from 'react';
import { IChipsOption } from '@cian/ui-kit/chips';

export const useScrollToActiveChip = (value: number[], options: IChipsOption<number>[]) => {
  const isFirstRender = React.useRef<boolean>(true);

  React.useEffect(() => {
    const activeOptionRef = options[value[0]]?.ref;

    if (isFirstRender.current && activeOptionRef && 'current' in activeOptionRef && activeOptionRef.current) {
      activeOptionRef.current.scrollIntoView({
        block: 'nearest',
        inline: 'center',
      });

      isFirstRender.current = false;
    }
  }, [value, options]);
};
